import React, { useContext } from 'react';
import { AppDataContext } from '../../../contexts/appData';
import { UserContext } from '../../../contexts/user';

const TbcDistributionModal = ({ callback }) => {
  const { langs } = useContext(AppDataContext);
  const { shop } = useContext(UserContext);
  const isOnlineShop = shop?.TypeID === 1;

  const onAgree = () => {
    callback(null, 'onAgree');
    callback(null, 'destroy');
  };

  const onReject = () => {
    callback(null, 'onReject');
    callback(null, 'destroy');
  };


  return (
    <div
      className="custom-modal-wrapper delivery-terms-modal content-scroll_ hide-scrollbar"
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '40px',  }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', padding: '0 24px', width: '100%', marginTop: '40px', gap: '8px' }}>
        <div className='d-flex'>
          <span className='font-bold text-black font-size-14 font-size-sm-16 font-size-md-20'>
            {langs.NM_InstallmentPlanTtitle}
          </span>
          <i className={`svg-i tbc-grey-i w-24px h-24px ml-8px`}></i>
          <i className={`svg-i credo-rounded w-24px h-24px ml-4px`}></i>
          <i className={`svg-i bog-rounded w-24px h-24px ml-4px`}></i>
        </div>

        <span className={'font-base text-black-70'} style={{ fontSize: '14px' }}>
          {isOnlineShop ? langs?.NM_B2C_BNPL_Plan : langs.NM_InstallmentPlan}
        </span>
      </div>

      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          gap: '12px',
          borderTop: '1px solid #EEE',
          padding: '0 24px',
          paddingTop: '16px',
        }}
      >
        <button
          className="btn font-size-14 w-100 font-bold"
          style={{ maxWidth: '140px', backgroundColor: '#f4f4f5', fontSize: '14px', color: '#272A37', borderRadius: '12px' }}
          onClick={onReject}
        >
          {langs.Cancel}
        </button>
        <button
          className="btn font-size-14 w-100 font-bold"
          style={{ maxWidth: '140px', backgroundColor: '#fec900', fontSize: '14px', color: '#222', borderRadius: '12px' }}
          onClick={onAgree}
        >
          {langs.Enable}
        </button>
      </div>
    </div>
  );
};

export default TbcDistributionModal;
